export type CtaAction =
  | 'access-dossier'
  | 'change-appointment'
  | 'create-new-password'
  | 'reset-password'
  | 'dossiers-search'
  | 'partners'
  | 'dashboard';
